



















































import { Component, Vue, Emit } from 'vue-property-decorator'
import { UserInfo } from '@/interfaces/vuexStateInterface'
import { getFigureCode, unbindSendCode, unbindPhone } from '@/apis/myInfo/myInfo.ts'
import { Toast } from 'vant'
import i18n from '@/lang';

@Component({})
export default class MobileFirst extends Vue {
  private isShowPopUp: boolean = false
  private picCodeInput: string = ''
  private checkPicCodeInputError: boolean = false
  private sessionid: string = ''
  private picCodeUrl: string = ''
  private unbind: boolean = false
  private virtCode: string = ''
  private codeMsg = i18n.t('ktpMy.请输入正确的验证码') as string
  get userInfo(): UserInfo {
    return this.$store.getters.getUserInfo
  }
  //调用父组件方法
  @Emit('showLast')
  showLast() {}
  //解除绑定
  Unbind() {
    // 进行请求验证码操作
    this.isShowPopUp = true
    this.getPicCode()
  }
  //解除绑定手机
  unbindMobile() {
    unbindPhone({ code: this.virtCode })
      .then((res: any) => {
        Toast.success(i18n.t('ktpMy.解除绑定成功'))
        this.codeMsg = res.message
        this.$store.dispatch('setUserInfo').then(() => {
          this.$router.go(-1)
        })
      })
      .catch((e) => {
        Toast.fail(i18n.t('ktpMy.解除绑定失败'))
        this.$router.go(-1)
      })
  }
  confirmPicCode() {
    unbindSendCode({ verify: this.picCodeInput, sessionid: this.sessionid })
      .then((res: any) => {
        // 说明输入正确
        this.checkPicCodeInputError = false
        this.isShowPopUp = false
        this.unbind = true
        this.$setNavInfo({
          type: 'normal',
          title: i18n.t('ktpMy.手机号') as string,
          showTitle: true,
          backConfig: () => {
            this.unbind = false
          },
        })
      })
      .catch((e) => {
        //输入错误
        this.codeMsg = e.message
        this.checkPicCodeInputError = true
        this.getPicCode()
      })
  }
  getPicCode() {
    getFigureCode()
      .then((res: any) => {
        console.log("mei")
        this.sessionid = res.sessionid
        this.picCodeUrl = res.url
      })
      .catch((e) => {
        Toast.fail(e.message)
      })
  }

  created() {
    this.$setNavInfo({
      type: 'normal',
      title: i18n.t('ktpMy.手机号') as string,
      showTitle: true,
      backConfig: () => {
        this.$router.push('/myAllSetting?detail=myAccountManage')
      },
    })
  }
}
